import { createSlice } from '@reduxjs/toolkit'
import { fetchReportsTemplate } from '@store/actions/reports-template.action'
import type { ReportsTemplateData } from '@services/api/report.api'

type ReportsTemplateState = {
  data: ReportsTemplateData | null
  loading: boolean
  error: string | null
}

const initialState: ReportsTemplateState = {
  data: null,
  loading: false,
  error: null,
}

const reportsTemplateSlice = createSlice({
  name: 'reportsTemplate',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchReportsTemplate.fulfilled, (state, action) => {
      state.data = action.payload
      state.loading = false
      state.error = null
    })
    builder.addCase(fetchReportsTemplate.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchReportsTemplate.rejected, (state, action) => {
      state.error = action.payload || action.error.message || null
      state.loading = false
    })
  },
})

export default reportsTemplateSlice.reducer
